/**
 * Utility functions to map between database year IDs and actual years
 * Database: 1 = 2021, 2 = 2022, 3 = 2023, 4 = 2024
 */

const BASE_YEAR = 2019;

/**
 * Convert database year ID to actual year
 * @param yearId - Year ID from database (1, 2, 3, 4)
 * @returns Actual year (2020, 2021, 2022, 2023)
 */
export const yearIdToYear = (yearId: string | number): string => {
  const id = typeof yearId === 'string' ? parseInt(yearId) : yearId;
  return (BASE_YEAR + id).toString();
};

/**
 * Convert actual year to database year ID
 * @param year - Actual year (2020, 2021, 2022, 2023)
 * @returns Year ID for database (1, 2, 3, 4)
 */
export const yearToYearId = (year: string | number): string => {
  const y = typeof year === 'string' ? parseInt(year) : year;
  return (y - BASE_YEAR).toString();
};

/**
 * Convert array of year IDs to actual years
 * @param yearIds - Array of year IDs from database
 * @returns Array of actual years
 */
export const mapYearIdsToYears = (yearIds: string[]): string[] => {
  return yearIds.map(yearIdToYear).sort((a, b) => parseInt(b) - parseInt(a));
};

/**
 * Get display year from database year
 * @param dbYear - Year value from database
 * @returns Display year string
 */
export const getDisplayYear = (dbYear: string | number): string => {
  return yearIdToYear(dbYear);
};

